// ============================================================
// Formatadores — padrão brasileiro
// ============================================================

/**
 * Formata valor como moeda BRL
 * Ex: 1234567.89 → R$ 1.234.567,89
 */
export function formatarMoeda(valor) {
  if (valor == null || isNaN(valor)) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(Number(valor));
}

/**
 * Formata número com separador de milhar
 * Ex: 1234567 → 1.234.567
 */
export function formatarNumero(valor) {
  if (valor == null) return '0';
  return new Intl.NumberFormat('pt-BR').format(Number(valor));
}

/**
 * Formata data no padrão dd/mm/yyyy
 * Aceita string ISO (2024-03-15) ou Date
 */
export function formatarData(data) {
  if (!data) return '—';
  // Se for string ISO sem hora, adiciona T12:00 para evitar problema de fuso
  const d = typeof data === 'string' && data.length === 10
    ? new Date(data + 'T12:00:00')
    : new Date(data);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/**
 * Formata data e hora no padrão dd/mm/yyyy HH:MM
 */
export function formatarDataHora(data) {
  if (!data) return '—';
  const d = new Date(data);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
}

/**
 * Formata CNPJ: 12.345.678/0001-90
 */
export function formatarCnpj(cnpj) {
  if (!cnpj) return '—';
  const n = cnpj.replace(/\D/g, '');
  if (n.length !== 14) return cnpj;
  return n.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}
